import React, { useEffect, useState } from "react";
import background from "./images/background.png";
import PlatformToggle from "./atoms/PlatformToggle";

const AddToHomePage = () => {
  const [platform, setPlatform] = useState("iphone");

  useEffect(() => {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) setPlatform("android");
    else if (/iPhone|iPad|iPod/.test(ua)) setPlatform("iphone");
  }, []);

  return (
    <div
      className="min-h-full px-6 py-16 font-quicksand"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="max-w-2xl mx-auto text-center space-y-5 px-5 py-6"
        style={{
          background: "rgba(255,255,255,0.92)",
          borderRadius: "20px",
          border: "2px solid #f9a8d4",
          boxShadow: "0 8px 32px rgba(176,106,179,0.12)",
        }}
      >
        <h1 className="text-lg font-bold" style={{ color: "#b06ab3" }}>
          📲 Agrega Karime Says a tu pantalla
        </h1>

        <p className="text-sm leading-relaxed" style={{ color: "#6b7280" }}>
          Para que la tengas en la palma de tu mano y recibas notificaciones
          perrísimas al instante 🐩💌
        </p>

        {/* Platform toggle */}
        <PlatformToggle platform={platform} onChange={setPlatform} />

        {/* Steps */}
        <div
          className="text-left text-sm space-y-2"
          style={{ color: "#6b7280" }}
        >
          {platform === "iphone" ? (
            <ol className="list-decimal list-inside space-y-2">
              <li>Abre Safari.</li>
              <li>Presiona el botón de compartir (cuadro con flechita 🔼).</li>
              <li>
                Selecciona{" "}
                <strong style={{ color: "#2d1f3d" }}>
                  "Agregar a pantalla de inicio"
                </strong>
                .
              </li>
              <li>Presiona "Agregar" arriba a la derecha.</li>
            </ol>
          ) : (
            <ol className="list-decimal list-inside space-y-2">
              <li>Abre Chrome.</li>
              <li>Presiona los tres puntitos arriba a la derecha ⋮</li>
              <li>
                Selecciona{" "}
                <strong style={{ color: "#2d1f3d" }}>
                  "Agregar a pantalla principal"
                </strong>
                .
              </li>
              <li>Confirma cuando se te lo pida.</li>
            </ol>
          )}
        </div>

        {/* Pro tip */}
        <div
          className="rounded-2xl p-4 text-sm text-left"
          style={{
            background: "rgba(196,181,253,0.12)",
            border: "1.5px solid #c4b5fd",
            color: "#6b7280",
          }}
        >
          💡 <strong style={{ color: "#b06ab3" }}>Pro tip:</strong> Si te sale
          una ventanita que dice "¿Quieres recibir notificaciones?", ¡di que sí,
          bb! 💌 Así te enteras antes que nadie cuando hay nuevas frases,
          votaciones o tendencias 🔥
        </div>
      </div>
    </div>
  );
};

export default AddToHomePage;
